import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentService } from '../../services/jrni/department.service';
import { AlertService } from '../../_alert';
import { NgxSpinnerService } from 'ngx-spinner';
import { BasketService } from '../../services/jrni/basket.service';
import { TranslateService } from '@ngx-translate/core';
import { DatastoreService } from '../../services/datastore.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { CapitaService } from '../../services/capita.service';
import { ApiService } from '../../services/jrni/api.service';
import { Meta } from '@angular/platform-browser';

@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
	selectedDepartment;
	pageTitle: string;
	confirmationPageText: string;
	purchase;
	bookings;
	selectedService;
	selectedLocation;
	address;
	selectedDate;
	selectedSlot;
	client;
	endSlot;
	total;
	extraDetailsPresent;
	bookingSummaryData = [];
	bookingNumber;
	selectedResource;
	selectedResourceObj;
	confirmPayment = false;
	adminMode = false;
	booking;
	isAdminJourney = false;
	agentMode: any;

	steps = [
		{ title: 'Booking questions', isActive: false },
		{ title: 'Choose appointment date and time', isActive: false },
		{ title: 'Your details', isActive: false },
		{ title: 'Summary', isActive: false },
		{ title: 'Confirmation', isActive: true },
	];

  meta = inject(Meta);
	constructor(
		private router: Router,
		private departmentService: DepartmentService,
		private alertService: AlertService,
		private spinner: NgxSpinnerService,
		private basketService: BasketService,
		public translateService: TranslateService,
		private servicesService: ServicesService,
		public datastoreService: DatastoreService,
		private availabilityService: AvailabilityService,
		private capitaService: CapitaService,
		private apiService: ApiService
	) { }

	restartJourney() {
		if (sessionStorage.getItem('journey')) {
			// this.router.navigate(['start/' + sessionStorage.getItem('journey')]);
			window.location.assign('/start/' + sessionStorage.getItem('journey'));
		} else {
			window.location.assign('/departments');
		}
	}

	// goToLogin() {
	//   window.location.href =
	//     'https://myceremony.staging.bookinglab.co.uk/essex-staging/52500/access';
	// }

	ngOnInit() {
    try {
      this.meta.removeTag('content="nopagereadaloud"');
    }
    catch (err) {
      // no issues
    }
		this.booking = JSON.parse(localStorage.getItem('booking'));
		this.scrollToTop();
		this.spinner.show();
		if (this.datastoreService.adminJourney) {
			this.isAdminJourney = true;
		}

		this.agentMode = localStorage.getItem('agent');
		// Use this.departmentService.getLocation() if the services are set on the children departments
		// Use this.departmentService.get() if the services are set on the parent department
		this.departmentService.getLocation().then(async (selectedDepartment) => {
			if (selectedDepartment === undefined) {
				this.restartJourney();
			} else {
				this.client = {
					first_name: this.datastoreService.booking.first_name,
					last_name: this.datastoreService.booking.last_name,
					email: this.datastoreService.booking.email,
				};
				this.selectedDepartment = await selectedDepartment.$getParent();
				console.log(
					'selectedDepartment',
					this.selectedDepartment,
					'location',
					selectedDepartment
				);
				// Get the configurable data
				if (this.selectedDepartment.hasOwnProperty('extra')) {
					// Set the title on the login page to the title from the business question
					this.selectedDepartment.extra.hasOwnProperty(
						'confirmation_page_title'
					)
						? (this.pageTitle =
							this.selectedDepartment.extra.confirmation_page_title)
						: (this.pageTitle = 'Confirmation title not set');
					// Set the extra text on the page to the text taken from the business question
					this.selectedDepartment.extra.hasOwnProperty('confirmation_page_text')
						? (this.confirmationPageText =
							this.selectedDepartment.extra.confirmation_page_text)
						: null;
				}

				// Get the selected service
				this.servicesService.get().then((service) => {
					console.log(service);
					this.selectedService = service;
					this.selectedService.calculated_duration =
						Number(this.datastoreService.extraDuration) +
						Number(this.selectedService.durations[0]);

					if (this.selectedService.extra?.online_payment == 'Yes') {
						this.confirmPayment = true;
					}
					if (this.datastoreService.adminJourney) {
						this.confirmPayment = false;
						this.adminMode = true;
					}

					this.datastoreService.bookingQuestions.forEach((question) => {
						if (this.datastoreService.bookingForm.value[question['id']]) {
							this.bookingSummaryData.push({
								name: question.name,
								answer: this.datastoreService.bookingForm.value[question.id],
								detail_type: question.detail_type,
								price: question.price,
							});
						}
					});
					// Check if the questions contain any other purchase details
					const extraDetails = this.bookingSummaryData.filter(
						(elem) => elem.detail_type !== 'check-price'
					);
					this.extraDetailsPresent = extraDetails?.length > 0;
					// Calculate purchase total
					const paidItems = this.bookingSummaryData.filter(
						(item) => item.detail_type === 'check-price'
					);
					this.total =
						paidItems.map((items) => items.price).reduce((a, b) => a + b, 0) +
						this.selectedService?.price;
				});

				// Get the selected slot
				if (this.datastoreService.selectedSlot) {
					this.availabilityService.getSelectedSlot().then((slot) => {
						this.selectedSlot = slot;
						console.log(slot);
						this.availabilityService.getEndSlot().then((slot) => {
							this.endSlot = slot;
						});
					});
				}
				// this.selectedSlot = this.datastoreService.selectedSlot;
				// Get the selected location
				// Use this.departmentService.getLocation() if the services are set on the children departments
				// Use this.departmentService.get() if the services are set on the parent department
				this.departmentService.getLocation().then((location) => {
					this.selectedLocation = location;
					location?.$getAddress().then((res) => {
						this.address = res;
					});
				});

				// get the this.datastoreService.lookupResponses and call the updateReference API
				let lookupResponses = this.datastoreService.lookupResponses;
				const selectedAddress = this.datastoreService.selectedAddress;

				// filter out nulls from the lookupResponses array
				lookupResponses = lookupResponses.filter((response) => response !== null);
				if (lookupResponses.length > 0) {
					for (let i = 0; i < lookupResponses.length; i++) {
						const response = lookupResponses[i];

						this.apiService.updateReference(
							response,
							this.booking,
							selectedAddress,
							i + 1
						)
							.then((res) => {
								console.log(`Reference response [${i + 1}]:`, res);
							})
							.catch((err) => {
								console.error(`Error updating reference [${i + 1}]`, err);
							});
					}

				}

				// Get the purchase
				this.basketService.getPurchase().then(
					async (purchase) => {
						this.purchase = purchase;

						this.bookingNumber = this.datastoreService.booking.id;

						// try {
						//   await this.apiService.resendConfirmation(
						//     this.selectedLocation,
						//     this.datastoreService.booking.id
						//   );
						// } catch (err) {
						//   console.error(err);
						// }

						const selectedResourceTmp = localStorage.getItem('resource');
						console.log(selectedResourceTmp);
						if (selectedResourceTmp && selectedResourceTmp !== 'undefined') {
							this.selectedResourceObj = JSON.parse(selectedResourceTmp);
						}
						this.selectedSlot = JSON.parse(localStorage.getItem('date'));
						this.selectedLocation = JSON.parse(
							localStorage.getItem('location')
						);
						this.selectedService = JSON.parse(localStorage.getItem('service'));
						this.booking = JSON.parse(localStorage.getItem('booking'));
						//recalculate the duration
						this.selectedService.calculated_duration =
							Number(this.datastoreService.extraDuration) +
							Number(this.selectedService.durations[0]);
						this.spinner.hide();
					},
					(err) => {
						// Fall back to localStorage — covers the Adelante flow where
						// basketService may not have a traditional purchase reference
						console.error('getPurchase error, falling back to localStorage:', err);
						const selectedResourceTmp = localStorage.getItem('resource');
						if (selectedResourceTmp && selectedResourceTmp !== 'undefined') {
							this.selectedResourceObj = JSON.parse(selectedResourceTmp);
						}
						this.selectedSlot = JSON.parse(localStorage.getItem('date'));
						this.selectedLocation = JSON.parse(localStorage.getItem('location'));
						this.selectedService = JSON.parse(localStorage.getItem('service'));
						this.booking = JSON.parse(localStorage.getItem('booking'));
						this.bookingNumber = this.datastoreService.booking?.id;
						if (this.selectedService?.durations) {
							this.selectedService.calculated_duration =
								Number(this.datastoreService.extraDuration) +
								Number(this.selectedService.durations[0]);
						}
						this.spinner.hide();
					}
				);
			}
		});
		this.clearStoredAnswers();
	}

	clearStoredAnswers() {
		this.datastoreService.bookingAnswers = undefined;
		this.datastoreService.bookingForm = undefined;
		this.datastoreService.companyQuestions = undefined;
		this.datastoreService.companyQuestionsForm = undefined;
		this.datastoreService.startQuestions = undefined;
		this.datastoreService.type_of_appointment = undefined;
		this.datastoreService.customerDetailsForm = undefined;
		this.datastoreService.serviceFees = undefined;
		this.basketService.currentBasket = undefined;
		this.basketService.currentServiceItem = undefined;
	}

	// print confirmation page
	print() {
		window.print();
	}

	// Start at the top of the page
	scrollToTop() {
		const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
		window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
	}
}
